export default __webpack_public_path__ + "static/media/road-hazard-slippery-shadow.83dfac9a.svg";